import UserTrackerInnerProvider from './UserTrackerInnerProvider'

export default UserTrackerInnerProvider
